import { defineStore } from 'pinia'
import { ref } from 'vue'
import { LINK_TRUST_REVOKED_KEY } from '~/constants/stripeLinkTrust.constants'
import { readLinkTrustRevocationsFromStorage } from '~/utils/readLinkTrustRevocationsFromStorage'

// Reactive so every mounted Payment Element reacts to a revoke or a cross-tab storage event.
export const useStripeLinkTrustStore = defineStore('stripeLinkTrust', () => {
  const initial =
    typeof window === 'undefined'
      ? { revocationsByIdentity: {}, universalRevokedAt: null }
      : readLinkTrustRevocationsFromStorage(() => localStorage, LINK_TRUST_REVOKED_KEY)

  const revocationsByIdentity = ref<Record<string, number>>(initial.revocationsByIdentity)
  const universalRevokedAt = ref<number | null>(initial.universalRevokedAt)

  return { revocationsByIdentity, universalRevokedAt }
})
